import { get } from 'core_main/request';
import { updateStore, getStore } from 'core_main/store';
import { makeSchedulesEndpoint } from './helpers';

export const fetchSchedules = (scheduleId?: string) => {
  const scheduleIdParam = scheduleId || getStore()?.schedule?.id;

  return get(makeSchedulesEndpoint(scheduleIdParam)).then((response) => {
    const { included, data } = response;
    const { id, attributes } = data;
    const { hours, name, timezone, timezoneOffset } = attributes;

    updateStore('schedule', {
      id,
      hours,
      name,
      timezone,
      timezoneOffset,
      holidays: included,
    });

    return response;
  });
};
